import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { map, tap } from 'rxjs/operators';
import { ServerInfoActions } from '../server/serverinfo-actions';
import { DeviceActions } from './device-actions';
/**
 * Created by ashok on 10/05/17.
 */

@Injectable()
export class DeviceActionEffects {

    constructor(private actions$: Actions, private deviceActions: DeviceActions) {
        //

    }

    // old code
    versionMatched$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ServerInfoActions.SERVER_INFO_MATCHES_CLIENT), map(() => {
                this.deviceActions.detectDevice();
            })
        ),
        { dispatch: false });



}